const Form = [
    {
        key: 'payer',
        type: 'text',
        label: 'name_on_card',
        value: ''
    },
    {
        key: 'creditCardNumber',
        type: 'CreditCardNumber',
        label: 'credit_card_number',
        value: '',
        args: {
            regx: '^[0-9]+$',
            maxLength: 16
        },
        helpertextcardtype: 'only_accepting_visa_or_mastercard'
    },
    {
        key: 'expDate',
        type: 'ExpDate',
        label: 'exp_date',
        value: '',
        placeholder: 'MM/YY'
    },
    {
        key: 'cvv',
        type: 'password',
        label: 'cvv',
        value: '',
        args: {
            regx: '[0-9]',
            maxLength: 4
        }
    }
]

export const CreditCardConfigs = { Form }
